import { inject, Injectable } from '@angular/core';
import { SharedMasterDataPharmacyChainPropertiesSchema } from '@libs/shared/domain/master-data/pharmacy-chain/shared-master-data-pharmacy-chain.properties.schema';
import { PharmacyChainService } from '@services/pharmacy-chains/pharmacy-chain.service';
import { Store } from '@services/store';
import { intersection } from 'lodash';
import { defer, firstValueFrom, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ChainsStore extends Store<SharedMasterDataPharmacyChainPropertiesSchema> {
  private readonly pharmacyService = inject(PharmacyChainService);

  protected getDataSource(key: string): Observable<any> {
    return this.pharmacyService.get(key);
  }

  getChains(chainNpis: string[]): Observable<SharedMasterDataPharmacyChainPropertiesSchema[]> {
    return defer(async () => {
      const fromStore = await this.getFromStore(chainNpis);
      if (fromStore) return Object.values(fromStore);
      return await this.loadChains(chainNpis);
    });
  }

  private async getFromStore(chainNpis: string[]) {
    const keys = await this.keys();
    const compare = intersection(chainNpis, keys);
    if (compare.length === chainNpis.length) {
      return await this.getMany(chainNpis);
    }
  }

  private async loadChains(chainNpis: string[]) {
    const data = await firstValueFrom(this.pharmacyService.search({ npis: chainNpis }, { pageSize: 1000 }));
    await Promise.all(data.items.map(item => this.set(item.npi, item)));
    return data.items;
  }
}
